import React from 'react';
import PropTypes from 'prop-types';
import { FullPageLoader, ToastMessage } from 'panamera-react-ui';
import { FormattedMessage as Translation } from 'react-intl';

export default ({ tracking = {}} = {}) => {
    return class asyncLoading extends React.Component {
        static propTypes = {
            error: PropTypes.object,
            pastDelay: PropTypes.bool,
            retry: PropTypes.func,
            track: PropTypes.func
        };

        constructor(props, context) {
            super(props);
            this.context = context;

            this.state = {
                showMessage: !!this.props.error
            };

            this.track();
        }

        componentDidUpdate() {
            if (this.props.error && !this.state.showMessage) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    showMessage: true
                });

                this.track();
            }
        }

        track() {
            if (this.props.error && tracking.error) {
                this.props.track(
                    tracking.error.event,
                    tracking.error.attrs
                );
            }
        }

        handleClose = () => {
            this.setState({
                showMessage: false
            });
        };

        render() {
            if (this.state.showMessage) {
                return (
                    <ToastMessage
                        expiration={ 6000 }
                        onExpired={ this.handleClose }
                    >
                        <Translation id="defaultError" />.&nbsp;
                        <a title="retry" onClick={ this.props.retry }>
                            <Translation id="retry" />
                        </a>
                    </ToastMessage>
                );
            }
            else if (this.props.pastDelay) {
                return <FullPageLoader />;
            }

            return null;
        }
    };
};
